// Compteur public de trésors scellés — homepage
// Sobre, ivoire, count-up doux, pulsation or discrète
import { useEffect, useState, useRef } from 'react';

const API = `${(process.env.REACT_APP_BACKEND_URL || 'https://bobine.live')}/api`;

const TresorsCounter = () => {
  const [target, setTarget] = useState(null);
  const [display, setDisplay] = useState(0);
  const [visible, setVisible] = useState(false);
  const rafRef = useRef(null);

  // Fetch count once
  useEffect(() => {
    let cancelled = false;
    fetch(`${API}/public/counters`)
      .then(r => r.json())
      .then(d => {
        if (cancelled || typeof d.tresors !== 'number') return;
        setTarget(d.tresors);
        // small delay before fade-in to let layout settle
        setTimeout(() => setVisible(true), 250);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  // Count-up animation when target arrives + becomes visible
  useEffect(() => {
    if (target === null || !visible) return;
    const start = performance.now();
    const duration = 1600;
    const tick = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3); // ease-out cubic
      setDisplay(Math.round(target * eased));
      if (t < 1) rafRef.current = requestAnimationFrame(tick);
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => { if (rafRef.current) cancelAnimationFrame(rafRef.current); };
  }, [target, visible]);

  if (target === null) return null;

  return (
    <div
      data-testid="tresors-counter"
      style={{
        textAlign: 'center',
        margin: '0 auto 56px',
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(12px)',
        transition: 'opacity 1s ease, transform 1s ease',
      }}
    >
      <div style={{ display: 'inline-flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
        <span
          aria-hidden="true"
          style={{
            width: 7, height: 7, borderRadius: '50%',
            background: '#D4AF37',
            boxShadow: '0 0 8px rgba(212,175,55,0.7)',
            animation: 'tresorsPulse 2.4s ease-in-out infinite',
          }}
        />
        <p style={{
          fontFamily: "'Georgia', 'Times New Roman', serif",
          fontSize: 11,
          letterSpacing: 2.2,
          textTransform: 'uppercase',
          color: 'rgba(247,230,189,0.55)',
          margin: 0,
        }}>
          Le sanctuaire grandit
        </p>
      </div>
      <p
        data-testid="tresors-counter-value"
        style={{
          fontFamily: "'Georgia', 'Times New Roman', serif",
          fontStyle: 'italic',
          fontSize: 22,
          lineHeight: 1.4,
          color: '#F7E6BD',
          margin: 0,
        }}
      >
        <span style={{ fontWeight: 600, fontSize: 26 }}>{display.toLocaleString('fr-FR')}</span>
        {' '}trésors déjà confiés à Bobine par nos familles
      </p>
      <style>{`
        @keyframes tresorsPulse {
          0%, 100% { opacity: 0.55; transform: scale(1); }
          50%      { opacity: 1;    transform: scale(1.25); }
        }
      `}</style>
    </div>
  );
};

export default TresorsCounter;
